import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {CompetitionService, ECaseSnackBarService} from 'synto-common';

@Component({
  selector: 'ecase-select-approval-cycle-dialog',
  templateUrl: './ecase-select-approval-cycle-dialog.component.html'
})
export class SelectEcaseApprovalCycleDialogComponent implements OnInit {
  @Input() availableApprovalCycles: any[];
  selectCycleDescriptionForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<SelectEcaseApprovalCycleDialogComponent>,
    public eCaseSnackBarService: ECaseSnackBarService,
    public formBuilder: FormBuilder,
    public competitionService: CompetitionService) {
  }

  ngOnInit(): void {
    const obj = {
      description: ['', [Validators.required]]
    };
    this.selectCycleDescriptionForm = this.formBuilder.group(obj);
  }

  onConfirm(): void {
    this.dialogRef.close({
      id: this.selectCycleDescriptionForm.controls.description.value,
      description: this.availableApprovalCycles.filter(e => e.id === this.selectCycleDescriptionForm.controls.description.value)[0].description
    });
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}
